// extracted by mini-css-extract-plugin
export default {"selects":"RepeatDelivery_selects__APCb7","checks":"RepeatDelivery_checks__gBJUX","form":"RepeatDelivery_form__uQf5o"};